function calculateLoanFormula(price, months) {
  const r = 0.01524;
  const n = months;

  const numerator = price * r * Math.pow(1 + r, n);
  const denominator = Math.pow(1 + r, n) - 1;

  return numerator / denominator;
}

export { calculateLoanFormula };
